import { useEffect, useState } from "react";
import MultiSelectDropdown from "../components/MultiSelectDropdown";
import "./css/booking-campaign.css";
import { Button } from "react-bootstrap";
import CustomInput from "../components/CustomInput";
import {
  pricingModels,
  goal,
  targetDays,
  age,
  contexts,
  gender,
  education,
  connectionTypes,
  interests,
  targetDevice,
  campaignType,
} from "../components/data";
import countrydata from "../../countries+states.json";
import { z } from "zod";
import { MdInsights } from "react-icons/md";
import DonutCharts from "../components/BookingPieChart";
import ImpressionsTable from "../components/ImpressionsTable";
import Footer from "../../components/Footer";
import SingleSelectDropdown from "../components/SingleSelectDropdown";
import CreateDigitalAd from "../components/CreateDigitalAd";
import { useQuery, useLazyQuery } from "@apollo/client";
import { useAtom } from "jotai";
import { adPayloadAtom } from "../../atom/digitalAdPayloadAtom";
import { parseISO } from "date-fns";
import {
  GET_DIGITAL_AD_SUPPORTED_COUNTRIES,
  GET_IMPRESSIONS,
} from "../../components/GraphQL/Queries";
import { Box, Flex, InputGroup, Select, Text } from "@chakra-ui/react";
import CountrySelect from "../components/CountrySelect";
import axios from "axios";
import { getMyCountryCurrency } from "../../utils/functions";

const CampaignBook = () => {
  const [tabs, setTabs] = useState(1);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [states, setStates] = useState([]);
  const [errors, setErrors] = useState({});
  const [locations, setLocations] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [radiusValues, setRadiusValues] = useState({});
  const [selectedCountriesImpression, setSelectedCountriesImpression] =
    useState(["Nigeria", "Cameroon", "Benin", "Chad"]);
  const [countryAuction, setCountryAuction] = useState([]);
  const [devices, setDevices] = useState(["Desktop", "Mobile", "Tablet"]);
  const [auctionData, setAuctionData] = useState([]);
  const [dailyImpressions, setDailyImpressions] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const [payload, setPayload] = useAtom(adPayloadAtom);

  const { data: countriesList } = useQuery(GET_DIGITAL_AD_SUPPORTED_COUNTRIES);
  const [
    queryImpressions,
    { data: fetchtImpressionsData, loading: fetchImpressionDataLoading },
  ] = useLazyQuery(GET_IMPRESSIONS);

  const countries = countriesList?.guest.getDigitalAdSupportedCountries?.map(
    (item) => item.country
  );

  useEffect(() => {
    const savedDraft = localStorage.getItem("digital-booking");

    if (savedDraft) {
      try {
        const parsedData = JSON.parse(savedDraft);

        setPayload({
          ...parsedData,
          startDate: parsedData.startDate
            ? parseISO(parsedData.startDate)
            : new Date(),
          endDate: parsedData.endDate
            ? parseISO(parsedData.endDate)
            : new Date(),
        });

        localStorage.removeItem("digital-booking"); // Clean up after restoring
      } catch (error) {
        console.error("Error parsing saved draft:", error);
      }
    }
  }, []);

  useEffect(() => {
    const start = new Date(payload.startDate); // Clone the date
    start.setDate(start.getDate() - 1); // Subtract 1 day

    const end = new Date(payload.endDate); // Clone the date
    end.setDate(end.getDate() - 1); // Subtract 1 day

    queryImpressions({
      variables: {
        target: {
          countries: payload.country?.length
            ? payload.country
            : ["Nigeria", "Cameroon", "Benin", "Chad"],
          targetDevices: payload?.targetDevice?.length
            ? payload.targetDevice.map((device) =>
                Number(
                  Object.keys(targetDevice).find(
                    (key) => targetDevice[key] === device
                  )
                )
              )
            : [0, 1], // Default value
        },
        startDate: start.toISOString(),
        endDate: end.toISOString(),
        filter: ["Country", "Device", "Websites"],
      },
    });
  }, [selectedCountry, payload.targetDevice]);

  useEffect(() => {
    const handleLocation = (position) => {
      setLatitude(position.coords.latitude);
      setLongitude(position.coords.longitude);
    };
    navigator.geolocation.getCurrentPosition(handleLocation);
  });

  useEffect(() => {
    const handleGetLocation = async () => {
      if (latitude && longitude) {
        try {
          const apiUrl = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`;
          const response = await axios.get(apiUrl);
          const { country } = response?.data?.address;
          const currencyCode = getMyCountryCurrency(country);
          console.log(currencyCode);
          setPayload((prev) => {
            return {
              ...prev,
              currency: currencyCode,
            };
          });
        } catch (error) {
          console.error("Error fetching location data:", error);
        }
      }
    };
    handleGetLocation();
  }, [latitude, longitude, setPayload]);

  console.log(payload);

  useEffect(() => {
    // Extract auctions for the selected devices
    const auctions = fetchtImpressionsData?.guest?.getImpressions[1]?.map(
      (item) => ({
        device: targetDevice[item.deviceTypeId],
        auctions: item.auctions,
      })
    );

    // Extract only device names and auction values
    const devices = auctions?.map((item) => item.device);
    const auctionValues = auctions?.map((item) => item.auctions);

    setDevices(devices);
    setAuctionData(auctionValues);

    // Extract countries and their auction data
    const countryAuctions =
      fetchtImpressionsData?.guest?.getImpressions[0]?.flatMap((itemAuction) =>
        countriesList?.guest?.getDigitalAdSupportedCountries
          ?.filter((item) => item.sussId === itemAuction.countryId)
          ?.map((item) => ({
            country: item.country,
            auctions: itemAuction.auctions,
          }))
      );

    // Extract only device names and auction values
    const countryNames = countryAuctions?.map((item) => item?.country);
    const countryAuction = countryAuctions?.map((item) => item?.auctions);

    setSelectedCountriesImpression(countryNames);
    setCountryAuction(countryAuction);

    const totalAuctions = fetchtImpressionsData?.guest?.getImpressions
      ?.flat() // Flatten the array of arrays into a single array
      ?.reduce((sum, impression) => sum + (impression.auctions || 0), 0);

    setDailyImpressions(totalAuctions);

    setPayload({ ...payload, impression: totalAuctions });
  }, [fetchtImpressionsData]);

  function formatNumber(num) {
    if (num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(1) + "B";
    } else if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1) + "M";
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(1) + "K";
    }
    return num;
  }

  // Combined schema for both components

  const handleSelect = (field, selectedOptions) => {
    setPayload((prevPayload) => ({
      ...prevPayload,
      [field]: selectedOptions,
    }));
  };

  // Handle country selection
  const handleCountrySelect = (selectedOptions) => {
    setSelectedCountry(selectedOptions);

    // Collect states from selected countries
    const statesOptions = selectedOptions.flatMap((selectedCountryName) => {
      const countryData = countrydata.find(
        (country) => country.name === selectedCountryName
      );
      return countryData?.states
        ? countryData.states.map(
            (state) => `${selectedCountryName}-${state.name}`
          )
        : [];
    });

    setStates(statesOptions);

    setLocations((prevLocations) => {
      const updatedLocations = selectedOptions.flatMap((country) => {
        // Check if country already has selected states
        const existingStates = prevLocations.filter(
          (loc) => loc.country === country && loc.state
        );

        return existingStates.length > 0
          ? existingStates // Keep selected states for that country
          : [{ country, city: null, radius: null }]; // Add if no states exist
      });

      // Ensure no duplicates
      const newLocations = Array.from(
        new Set(updatedLocations.map(JSON.stringify))
      ).map(JSON.parse);

      // Update payload inside the same callback to use the correct state
      setPayload((prev) => ({
        ...prev,
        locations: newLocations,
      }));

      return newLocations;
    });

    setSelectedCountriesImpression(selectedOptions);
    handleSelect("country", selectedOptions);
    handleSelect("states", []);
  };

  // Handle state selection
  const handleStateSelect = (selectedOptions) => {
    setSelectedStates(selectedOptions);

    setLocations((prevLocations) => {
      const newLocations = selectedOptions.map((stateName) => {
        const [country, state] = stateName.split("-");
        const existingLocation = prevLocations.find(
          (loc) => loc.country === country && loc.city === state
        );

        return (
          existingLocation || {
            country,
            city: state,
            radius: radiusValues[state] || "", // Preserve existing radius values
          }
        );
      });

      // Remove `{ country, state: null, radius: null }` if country now has states
      const filteredLocations = prevLocations.filter(
        (loc) =>
          !(
            selectedOptions.some((s) => s.startsWith(loc.country)) &&
            loc.city === null
          )
      );

      // Ensure unique locations
      const mergedLocations = [...filteredLocations, ...newLocations].filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) => t.country === value.country && t.state === value.state
          )
      );

      //Update payload inside `setLocations`
      setPayload((prev) => ({
        ...prev,
        locations: mergedLocations,
      }));

      return mergedLocations;
    });

    handleSelect("states", selectedOptions);
  };

  // Handle radius input change
  const handleRadiusChange = (state, value) => {
    const [country, selectedState] = state.split("-");

    setRadiusValues((prev) => ({ ...prev, [state]: value }));

    setLocations((prevLocations) => {
      const updatedLocations = prevLocations.map((location) =>
        location.city === selectedState && location.country === country
          ? { ...location, radius: parseFloat(value) }
          : location
      );

      //Update payload inside `setLocations`
      setPayload((prev) => ({
        ...prev,
        locations: updatedLocations,
      }));

      return updatedLocations;
    });
  };

  const combinedSchema1 = z.object({
    // CampaignBook fields
    campaignName: z
      .string()
      .min(3, "Provide a campaign name with at least 3 letters")
      .optional(),

    campaignType: z.string().min(1, "Provide a campaign type"),
    pricingModels: z.string().min(1, "Please select pricing models").optional(),
    goal: z.string().min(1, "Please select goal").optional(),
    budget: z
      .number()
      .min(100, "Budget is required and must be at least 100 USD"),
    description: z
      .string()
      .min(5, "Please provide campaign description")
      .optional(),
    // country: z.string().min(1, "Select a country"),
    // states: z.string().min(1, "Select a state"),
    companyDomain: z
      .string()
      .url("Invalid URL. Please enter a valid company URL.")
      .optional(),

    targetDays: z
      .array(z.string())
      .min(1, "Choose your target days")
      .optional(),
    targetDevice: z
      .array(z.string())
      .min(1, "Select preferred device")
      .optional(),
    age: z
      .array(z.string())
      .min(1, "Select at least one date range")
      .optional(),
    gender: z.array(z.string()).min(1, "Select at least one gender").optional(),
    education: z
      .array(z.string())
      .min(1, "Select at least one education level"),
    connectionTypes: z
      .array(z.string())
      .min(1, "Select at least one connection type")
      .optional(),
    interests: z
      .array(z.string())
      .min(1, "Select at least one interest")
      .optional(),
    contexts: z
      .array(z.string())
      .min(1, "Select at least one context")
      .optional(),
  });

  // CreateDigitalAd fields
  const combinedSchema2 = z.object({
    companyNames: z
      .string()
      .min(3, "Provide a company name with at least 3 letters"),
    adTitle: z.string().min(3, "Ad title must be at least 3 characters"),
    dailyamount: z.number().min(1, "Daily amount must be greater than 0"),
    startDate: z.date(),
    endDate: z.date(),
    targetUrl: z.string().url("Invalid URL. Please enter a valid target URL."),
    descriptionAd: z
      .string()
      .min(10, "Description must be at least 10 characters"),
    creativeTitle: z.string().min(3, "Creative title is required"),
    creativeDescription: z
      .string()
      .min(10, "Description must be at least 10 characters"),
    creativeUrl: z.string().url("Invalid URL").optional(),
    // cappingImpressions: z.boolean(),
    // campaignImpressionPerTimes: z.number().min(1, "Must be at least 1"),
    // campaignImpressionPerHour: z.number().min(1, "Must be at least 1"),
    // cappingClicks: z.boolean(),
    // campaignClickPerTimes: z.number().min(1, "Must be at least 1"),
    // campaignClickPerHour: z.number().min(1, "Must be at least 1"),
  });

  // Dynamically validate optional fields when present
  const combinedSchema = combinedSchema1
    .merge(combinedSchema2)
    .superRefine((data, ctx) => {
      const optionalFieldValidators = {
        campaignName: z
          .string()
          .min(3, "Provide a campaign name with at least 3 letters"),
        pricingModels: z.string().min(1, "Please select pricing models"),
        goal: z.string().min(1, "Please select goal"),
        description: z.string().min(5, "Please provide campaign description"),
        companyDomain: z
          .string()
          .url("Invalid URL. Please enter a valid company URL."),
        targetDays: z.array(z.string()).min(1, "Choose your target days"),
        targetDevice: z.array(z.string()).min(1, "Select preferred device"),
        age: z.array(z.string()).min(1, "Select at least one date range"),
        gender: z.array(z.string()).min(1, "Select at least one gender"),
        connectionTypes: z
          .array(z.string())
          .min(1, "Select at least one connection type"),
        interests: z.array(z.string()).min(1, "Select at least one interest"),
        contexts: z.array(z.string()).min(1, "Select at least one context"),
      };

      for (const key in optionalFieldValidators) {
        const value = data[key];
        if (value !== undefined) {
          const result = optionalFieldValidators[key].safeParse(value);
          if (!result.success) {
            result.error.errors.forEach((error) => {
              ctx.addIssue({
                path: [key],
                message: error.message,
                code: z.ZodIssueCode.custom,
              });
            });
          }
        }
      }
    });

  const handleNextTab = () => {
    try {
      combinedSchema1.parse(payload);
      setErrors({}); // Clear errors if validation passes
      setTabs(2); // Proceed to the next tab
    } catch (err) {
      const validationErrors = {};
      console.log(err);
      err.errors.forEach((error) => {
        validationErrors[error.path[0]] = error.message;
      });
      setErrors(validationErrors); // Assuming React useState
    }
  };

  return (
    <>
      <div className="pre-booking pred-campaign-wrapper">
        <main>
          <section className=" pre-booking-wrappered">
            <div className="pre-booking-campaign-header">
              <div className="pre-booking-campaign-header-text">
                <p className="pre-booking-campaign-header-text-head">
                  Campaign Builder
                </p>
                <p className="pre-booking-campaign-header-sub">
                  Build Campaign
                </p>
              </div>
            </div>
            <hr className="hr-bar" />
            <div className="pre-booking-multi-select-tabs">
              <button
                className={`pre-booking-multi-select-tab `}
                onClick={() => setTabs(1)}
              >
                <span
                  className={`pre-booking-select-tab-index ${
                    tabs === 1 ? "active-index" : ""
                  }`}
                >
                  {tabs === 1 ? (
                    "1"
                  ) : (
                    <span className="active-index-check">✓</span>
                  )}
                </span>
                <span>Campaign Setup</span>
              </button>
              <button
                className={`pre-booking-multi-select-tab`}
                onClick={() => handleNextTab()}
              >
                <span
                  className={`pre-booking-select-tab-index ${
                    tabs === 2 ? "active-index" : "not-active-index"
                  }`}
                >
                  2
                </span>
                <span>Ad Setup</span>
              </button>
            </div>
            <hr className="hr-bar" />
            {tabs === 1 ? (
              <div className="pre-booking-campaign-body-page">
                <div className="pre-campaign-input-wrapper">
                  <div className="pre-booking-multi-select-main-wrapper">
                    <div className="pre-booking-multi-first-wrapper">
                      <div className="pre-booking-multi-select-header">
                        <p>Campaign Details</p>
                      </div>
                      <hr className="hr-bar" />
                      <div className="pre-booking-campaign-details-wrapper">
                        <div className="pre-booking-campaign-details-input">
                          <CustomInput
                            label="Campaign Name"
                            type="text"
                            value={payload.campaignName}
                            setValue={(value) =>
                              setPayload({ ...payload, campaignName: value })
                            }
                            required={true}
                            isError={!!errors.campaignName}
                            errorMessage={errors.campaignName || ""}
                          />
                        </div>
                        <div className="pre-booking-campaign-details-input">
                          <SingleSelectDropdown
                            label="Campaign Type"
                            options={Object.values(campaignType)}
                            required={true}
                            name="campaignType"
                            selectedOption={payload?.campaignType}
                            setSelectedOption={(selectedOptions) =>
                              handleSelect("campaignType", selectedOptions)
                            }
                            isError={!!errors.campaignType}
                            errorMessage={errors.campaignType || ""}
                          />
                        </div>
                      </div>
                      <div className="pre-booking-campaign-details-wrapper">
                        <div className="pre-booking-campaign-details-input">
                          <SingleSelectDropdown
                            label="Pricing Model"
                            options={Object.values(pricingModels)}
                            required={true}
                            name="pricingModels"
                            selectedOption={payload?.pricingModels}
                            setSelectedOption={(selectedOptions) =>
                              handleSelect("pricingModels", selectedOptions)
                            }
                            isError={!!errors.pricingModels}
                            errorMessage={errors.pricingModels || ""}
                          />
                        </div>
                        <div className="pre-booking-campaign-details-input">
                          <SingleSelectDropdown
                            label="Goal"
                            options={goal}
                            name="goal"
                            required={true}
                            selectedOption={payload?.goal}
                            setSelectedOption={(selectedOptions) =>
                              handleSelect("goal", selectedOptions)
                            }
                            isError={!!errors.goal}
                            errorMessage={errors.goal || ""}
                          />
                        </div>
                      </div>

                      <div className="pre-booking-campaign-details-wrapper">
                        <div className="pre-booking-campaign-details-input">
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              // gap: "10px",
                            }}
                          >
                            <InputGroup
                              size="sm"
                              display={"flex"}
                              alignItems={"baseline"}
                            >
                              <select
                              className="currency-dropdown"
                                value={payload.currency}
                                onChange={(e) =>
                                  setPayload({
                                    ...payload,
                                    currency: e.target.value,
                                  })
                                }
                              >
                                <option value="USD">USD</option>
                                <option value="NGN">NGN</option>
                              </select>
                              
                                <CustomInput
                                  label="Budgets"
                                  type="number"
                                  name="budget"
                                  value={payload.budget}
                                  setValue={(value) =>
                                    setPayload({
                                      ...payload,
                                      budget: Number(value),
                                    })
                                  }
                                  required={true}
                                  isError={!!errors.budget}
                                  errorMessage={errors.budget || ""}
                                  min={100}
                                />
                            </InputGroup>
                          </div>
                        </div>
                        <div className="pre-booking-campaign-details-input-half">
                          <CustomInput
                            label="Description"
                            type="text"
                            value={payload.description}
                            setValue={(value) =>
                              setPayload({ ...payload, description: value })
                            }
                            required={true}
                            isError={!!errors.description}
                            errorMessage={errors?.description || ""}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="pre-booking-multi-select-main-wrapper">
                    <div className="pre-booking-multi-first-wrapper">
                      <div className="pre-booking-multi-select-header">
                        <p>Targeting</p>
                      </div>
                      <hr className="hr-bar" />
                      <div className="pre-booking-campaign-details-wrapper">
                        <div className="pre-booking-campaign-details-input">
                          <CountrySelect
                            label="Country"
                            options={countries}
                            name="country"
                            required={true}
                            selectedOptions={selectedCountry}
                            setSelectedOptions={setSelectedCountry}
                            handleSelect={handleCountrySelect}
                          />
                        </div>
                        <div className="pre-booking-campaign-details-input">
                          <MultiSelectDropdown
                            label="States"
                            options={states}
                            required={true}
                            name="states"
                            selectedOptions={selectedStates}
                            setSelectedOptions={handleStateSelect}
                          />
                        </div>
                      </div>
                      <div className="pre-booking-campaign-details-input">
                        {/* Dynamic Radius Inputs for Selected States */}
                        {selectedStates.map((state) => (
                          <div className="pre-booking-campaign-details-input-half">
                            <CustomInput
                              label={`Radius for ${state.split("-")[1]}`}
                              type="number"
                              placeholder="Enter radius in km"
                              value={radiusValues[state] || ""}
                              setValue={(value) =>
                                handleRadiusChange(state, value)
                              }
                              required={true}
                              // isError={!!errors.description}
                              // errorMessage={errors?.description || ""}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="pre-booking-multi-select-main-wrapper">
                    <div className="pre-booking-multi-first-wrapper">
                      <div className="pre-booking-multi-select-header">
                        <p>Other</p>
                      </div>
                      <hr className="hr-bar" />
                      <div className="pre-booking-campaign-details-wrapper">
                        <div className="pre-booking-campaign-details-input">
                          <CustomInput
                            label="Company Domains"
                            type="text"
                            value={payload.companyDomain}
                            setValue={(value) =>
                              setPayload({ ...payload, companyDomain: value })
                            }
                            placeholder="https://example.com"
                            required={true}
                            isError={!!errors.companyDomain}
                            errorMessage={errors.companyDomain || ""}
                          />
                        </div>
                        <div className="pre-booking-campaign-details-input">
                          <MultiSelectDropdown
                            label="Target Days"
                            options={Object.values(targetDays)}
                            required={true}
                            name="targetDays"
                            selectedOptions={payload?.targetDays}
                            setSelectedOptions={(selectedOptions) =>
                              handleSelect("targetDays", selectedOptions)
                            }
                            isError={!!errors.targetDays}
                            errorMessage={errors.targetDays || ""}
                          />
                        </div>
                      </div>
                      <div className="pre-booking-campaign-details-wrapper">
                        <div className="pre-booking-campaign-details-input">
                          <MultiSelectDropdown
                            label="Target Devices"
                            options={Object.values(targetDevice)}
                            name="targetDevice"
                            required={true}
                            selectedOptions={payload?.targetDevice}
                            setSelectedOptions={(selectedOptions) =>
                              handleSelect("targetDevice", selectedOptions)
                            }
                            isError={!!errors.targetDevice}
                            errorMessage={errors.targetDevice || ""}
                          />
                        </div>
                        <div className="pre-booking-campaign-details-input">
                          <MultiSelectDropdown
                            label="Age"
                            options={age}
                            name="age"
                            required={true}
                            selectedOptions={payload?.age}
                            setSelectedOptions={(selectedOptions) =>
                              handleSelect("age", selectedOptions)
                            }
                            isError={!!errors.age}
                            errorMessage={errors.age || ""}
                          />
                        </div>
                      </div>

                      <div className="pre-booking-campaign-details-wrapper">
                        <div className="pre-booking-campaign-details-input">
                          <MultiSelectDropdown
                            label="Gender"
                            name="gender"
                            options={gender}
                            required={true}
                            selectedOptions={payload?.gender}
                            setSelectedOptions={(selectedOptions) =>
                              handleSelect("gender", selectedOptions)
                            }
                            isError={!!errors.gender}
                            errorMessage={errors.gender || ""}
                          />
                        </div>
                        <div className="pre-booking-campaign-details-input">
                          <MultiSelectDropdown
                            label="Education"
                            options={education}
                            required={true}
                            name="education"
                            selectedOptions={payload?.education}
                            setSelectedOptions={(selectedOptions) =>
                              handleSelect("education", selectedOptions)
                            }
                            isError={!!errors.education}
                            errorMessage={errors.education || ""}
                          />
                        </div>
                      </div>
                      <div className="pre-booking-campaign-details-wrapper">
                        <div className="pre-booking-campaign-details-input">
                          <MultiSelectDropdown
                            label="Connection Types"
                            options={Object.values(connectionTypes)}
                            required={true}
                            name="connectionTypes"
                            selectedOptions={payload?.connectionTypes}
                            setSelectedOptions={(selectedOptions) =>
                              handleSelect("connectionTypes", selectedOptions)
                            }
                            isError={!!errors.connectionTypes}
                            errorMessage={errors.connectionTypes || ""}
                          />
                        </div>
                        <div className="pre-booking-campaign-details-input">
                          <MultiSelectDropdown
                            label="Interests"
                            options={interests}
                            required={true}
                            name="interests"
                            selectedOptions={payload?.interests}
                            setSelectedOptions={(selectedOptions) =>
                              handleSelect("interests", selectedOptions)
                            }
                            isError={!!errors.interests}
                            errorMessage={errors.interests || ""}
                          />
                        </div>
                      </div>
                      <div className="pre-booking-campaign-details-wrapper">
                        <div className="pre-booking-campaign-details-input-half">
                          <MultiSelectDropdown
                            label="Contexts"
                            options={contexts}
                            name="contexts"
                            required={true}
                            selectedOptions={payload?.contexts}
                            setSelectedOptions={(selectedOptions) =>
                              handleSelect("contexts", selectedOptions)
                            }
                            isError={!!errors.context}
                            errorMessage={errors.context || ""}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="pre-booking-campaign-submit-button-footer">
                    <Button
                      className="pre-booking-campaign-submit-button"
                      //   disabled={!isFormValid}
                      onClick={handleNextTab}
                    >
                      Create Campaign
                    </Button>
                  </div>
                </div>

                <div className="pre-booking-campaign-left-body-wrapper">
                  <div className="pre-booking-campaign-second-header">
                    <p className="pre-booking-multi-select-header">
                      Transmits Ads Reach
                    </p>
                    <p className="pre-booking-multi-select-sub">
                      Potential daily impressions and inventory distribution
                    </p>
                  </div>
                  <div className="pre-booking-campaign-second-body-bar">
                    <hr className="hr-bar" />
                  </div>

                  <div className="pre-booking-campaign-second-body">
                    <div className="pre-booking-campaign-second-body-text-wrap">
                      <div className="pre-booking-campaign-second-body-icon-wrap">
                        <MdInsights className="pre-booking-campaign-second-body-icon" />
                      </div>
                      <div>
                        <p className="pre-booking-campaign-second-body-text">
                          Potential Daily Impressions
                        </p>
                        {fetchImpressionDataLoading ? (
                          <Flex
                            justifyContent={"center"}
                            alignItems={"center"}
                            flexDirection={"column"}
                            gap={6}
                            height={"100%"}
                          >
                            <span class="loader"></span>
                            <Text color="colorPalette.600">Loading...</Text>
                          </Flex>
                        ) : (
                          <p className="pre-booking-campaign-second-body-text-sub">
                            {formatNumber(dailyImpressions)}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="pre-booking-campaign-second-body-charts">
                      <DonutCharts
                        targetDevices={devices}
                        auctionData={auctionData}
                        selectedCountriesImpression={
                          selectedCountriesImpression
                        }
                        countryAuction={countryAuction}
                        isLoading={fetchImpressionDataLoading}
                      />
                    </div>
                    <div className="pre-booking-campaign-second-body-table">
                      <ImpressionsTable
                        data={fetchtImpressionsData?.guest?.getImpressions[2]}
                        isLoading={fetchImpressionDataLoading}
                        formatNumber={formatNumber}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <CreateDigitalAd combinedSchema={combinedSchema} />
            )}
          </section>
        </main>
        <footer>
          <Footer />
        </footer>
      </div>
    </>
  );
};

export default CampaignBook;
